import useNode from '../models/useNode'
import useNetwork from '../models/useNetwork'
import useOrganizations from '../models/useOrganizations'
import { outsideNodes, type OutsideGroup } from '../utilities/nodeGroups'

/**
 * The active org's nodes that no network view draws (app#388): a node in a network of another org,
 * and a node in no network. Each with its group. `useMergedData` keeps only nodes whose network is
 * loaded, so it never returns these; the Nodes tab and the node page read them here.
 *
 * ⚠ Not memoized: the stores give new arrays on each change, and the list is short.
 */
const useOutsideNodes = (): Array<{ node: NodeRecord; group: OutsideGroup }> => {
  const nodes = useNode(state => state.nodes)
  const networks = useNetwork(state => state.networks)
  const networksOrgId = useNetwork(state => state.loadedOrgId)
  const activeOrgId = useOrganizations(state => state.activeOrgId)
  // `null` until the network list is the ACTIVE org's: see `outsideNodes`.
  const loadedNetworkIds =
    networksOrgId === activeOrgId ? new Set(networks.flatMap(n => (n.id ? [n.id] : []))) : null
  return outsideNodes(nodes, loadedNetworkIds, activeOrgId)
}

export default useOutsideNodes
